import React from "react";
import { Container, Grid, makeStyles, Typography } from "@material-ui/core";
import Layout from "../components/Layout/Layout";
import { APP_TITLE } from "../constants/title";
import { Helmet } from "react-helmet";
import LpCollectionOfExamples from "../components/LpCollectionOfExamples/LpCollectionOfExamples";

const useStyles = makeStyles((theme) => ({
  title: {
    textAlign: "center",
    fontSize: 36,
    fontWeight: 800,
    color: "#000",
    lineHeight: 1.15,
    [theme.breakpoints.up("md")]: {
      fontSize: 58,
    },
  },
  image: {
    borderRadius: "50%",
    width: 180,
  },
  name: {
    marginTop: theme.spacing(2),
    textAlign: "center",
    fontSize: 24,
    fontWeight: 500,
    color: "#000",
    lineHeight: 1.25,
    marginBottom: theme.spacing(2),
  },
}));

const AboutUsView = () => {
  const classes = useStyles();

  return (
    <>
      <Layout title={"Fífovo sbírky příkladů"}>
        <Container maxWidth={"lg"} className={"landingPageView"}>
          <Grid
            container
            spacing={2}
            style={{ marginTop: 8, marginBottom: 16, alignItems: "center" }}
            className={"landingPageView"}
          >
            <Grid item xs={12} md={6}>
              <Typography variant={"h1"}>Fífovo sbírky příkladů</Typography>
              <Typography>
                Videa jsou fajn věc, ale je to jako se sexem. Š*ukat se z teorie
                prostě nenaučíš. Prostě to chce praxi. Počítat, počítat,
                počítat. Udělal jsem vlastní sbírky k průběžnejm i závěrečnejm
                testům, abys to počítal fakt jen podle toho, co tam bude.
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} style={{ textAlign: "center" }} />
          </Grid>

          <Grid
            container
            spacing={2}
            style={{ marginTop: 8, marginBottom: 16, alignItems: "center" }}
          >
            <Grid item xs={12}>
              <LpCollectionOfExamples />
            </Grid>
          </Grid>
        </Container>
      </Layout>
    </>
  );
};

export default AboutUsView;
